<template>
  <div>
    <ListagemRotaComponent />
  </div>
</template>

<script>


import ListagemRotaComponent from '../components/ListagemRotaComponent.vue'
export default {
  components: { ListagemRotaComponent },
  name: 'RotasPage',

  data () {
    return {
      
    }
  }
}
</script>
